// src/components/suiviEnseignants/apiSuiviEnseignants.js
// Appels de la direction vers /api/suivi-enseignants (jeton employé).
//
// Remplace, pour l'écran « Suivi des enseignants », les lectures de
// /api/suivi-pedagogique/direction/* de l'ancien écran (SuiviEnseignantsDirection,
// laissé mort) : la direction suit chaque enseignant et COMMENTE un programme,
// elle ne le valide plus (décision de Daniel du 6 octobre 2026).
//
// C'est le jeton de l'ADMINISTRATION qui part ici (getAuthHeaders, clé
// `token`), jamais celui de l'espace enseignant.

import { getAuthHeaders } from '../../services/api';

const RACINE = '/api/suivi-enseignants';

const LICENCE_FERMEE = "Le suivi des enseignants n'est pas inclus dans la licence de cet établissement.";
const NON_INSTALLE = "Le suivi des enseignants n'est pas encore installé dans cet établissement.";

// Même lecture des refus que les autres écrans de l'espace enseignant côté
// école (apiAccesEnseignant.js) : le refus de licence n'a pas de `message`
// français, une route absente ou une table pas encore créée dit que le module
// n'est pas installé, le reste s'affiche tel que le serveur l'a écrit.
function erreurDuServeur(reponse, donnees, defaut) {
  let message = donnees?.message;
  if (!message && (donnees?.code === 'FEATURE_NOT_LICENSED' || reponse.status === 403)) message = LICENCE_FERMEE;
  if (!message && (reponse.status === 503 || (reponse.status === 404 && !donnees))) message = NON_INSTALLE;
  const erreur = new Error(message || donnees?.error || defaut);
  erreur.code = donnees?.code;
  erreur.statut = reponse.status;
  return erreur;
}

async function appeler(chemin, { methode = 'GET', corps } = {}) {
  let reponse;
  try {
    reponse = await fetch(`${RACINE}${chemin}`, {
      method: methode,
      headers: getAuthHeaders(),
      body: corps !== undefined ? JSON.stringify(corps) : undefined
    });
  } catch {
    throw new Error('Connexion au serveur impossible.');
  }
  let donnees = null;
  try { donnees = await reponse.json(); } catch { donnees = null; }
  if (!reponse.ok) throw erreurDuServeur(reponse, donnees, 'Une erreur est survenue.');
  return donnees;
}

// La semaine part telle quelle, n'importe quel jour : c'est le serveur qui en
// calcule le lundi, en SQL. Sans elle, il prend la semaine en cours.
const avecSemaine = (semaine) => (semaine ? `?semaine=${encodeURIComponent(semaine)}` : '');

export const suiviEnseignants = {
  vueGlobale: (semaine) => appeler(avecSemaine(semaine)),
  enseignant: (employeId, semaine) => appeler(`/${encodeURIComponent(employeId)}${avecSemaine(semaine)}`),
  /** → les commentaires du programme, relus par le serveur. */
  commenter: (programmeId, texte) => appeler(`/programmes/${programmeId}/commentaires`, { methode: 'POST', corps: { texte } }),
  supprimerCommentaire: (commentaireId) => appeler(`/commentaires/${commentaireId}`, { methode: 'DELETE' })
};
